import React, { Component } from 'react'
import MaterialTable, { MTableToolbar } from 'material-table'

import Parse from 'widget/parse'
import localization from 'widget/MaterialTableOpt'

const columns = () => ([
  { title: '單據單號', field: 'documentNum' },
  { title: '單據日期', field: 'documentDate' },
  { title: '倉管人員', field: 'warehouseStaff' },
  { title: '廠商編號', field: 'manufacturerID' },
  { title: '廠商名稱', field: 'tradeNames' },
  { title: '參考單號', field: 'referenceNum' },
  { title: '參考日期', field: 'referenceDate' },
  { title: '單據摘要', field: 'documentSummary' },
  { title: '隸屬公司', field: 'affiliatedCompany' },
  { title: '是否關帳', field: 'whetherToCloseTheAccount' },
  { title: '結帳日期', field: 'checkoutDate' },
  { title: '序號', field: 'serialNum' },
  { title: '零件編號', field: 'partNum' },
  { title: '零件級別', field: 'partLevel' },
  { title: '計算單位', field: 'unitOfMeasurement' },
  { title: '庫存儲位', field: 'inventoryStorage' },
  { title: '單價', field: 'unitPrice' },
  { title: '數量', field: 'quantity' },
  { title: '金額', field: 'amount' },
  { title: '零件規格', field: 'partSpecifications' },
  { title: '備註說明', field: 'instructionManual' },
]);

export default class Hr1 extends Component {
  state = {
    dataArr: [],
    filenames: [],
    downloadURLs: [],
    docs: [],
    fileArr: [],
    fileArrCheck: [],
    show: false,
    // loading: true,
    obj: {}
  }

  // componentDidMount() {
  //   this.handleFetch();
  // }

  // componentWillReceiveProps(nextProps) {
  //   this.handleFetch(nextProps);
  // }

  // handleFetch = async (props = this.props) => {
  //   const { companyObj } = props;

  //   const companyId = companyObj.objectId;
  //   const data = await Parse.queryData('hrform_management', { companyId });
  //   this.setState({ dataArr: data, loading: false });
  // }

  // handleUpdate = async () => {
  //   const { newData } = this.state
  //   await Parse.saveData('hrform_management', newData);
  // }

  render() {
    const { dataArr, loading } = this.state;

    return (<div className='content'>
      {/* <Container> */}
      {/* <div style={{ ...style.flexCenter, position: 'relative', zIndex: 100 }}>
          <Header as='h2' style={{ margin: '2rem 0' }}>4-1 人事規章</Header>
        </div> */}
      <br />
      <br />
      <MaterialTable
        isLoading={loading}
        localization={localization()}
        columns={columns()}
        options={{
          pageSize: 5,
          search: true,
          searchFieldStyle: {
            width: 90,
          }
        }}
        data={dataArr}
        title={'零件進貨單'}
      />
      <br />
      <br />
    </div>)
  }
}